import React, { useState, useEffect } from "react";
import "../account-details/account-details.scss";
import AddressImg from "../../assets/accounts/address.svg";
import InfoImg from "../../assets/accounts/info.svg";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from "react-accessible-accordion";
import PageHeader from "../../components/table/pageHeader/PageHeader";
import useInvoice from "../../controller/invoice-controller";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import { formateDate, getFormatedData, numberFormat } from "../../utils/helper";
import { useNavigate, useParams } from "react-router-dom";
import Invoices from "../../assets/sidebar/dealerPortal/Invoices";
// import InfoVector from "../../assets/InfoVector";
import TrackingSvg from "../../assets/TrackingSvg";
import PaymentSvg from "../../assets/PaymentSvg";
import TaxSvg from "../../assets/TaxSvg";
import Order2Img from "../../assets/orders/order_2.svg";

const InvoicesDetails = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { invDetail, errMsg, isLoading, getInvoiceDetails } = useInvoice();
  const [isLoader, setIsLoader] = useState(false);
  const [invInfo, setInvInfo] = useState({});
  const [openAcc, setOpenAcc] = useState(["0", "1", "2", "3", "4", "5", "6"]);

  useEffect(() => {
    getInvoiceDetails(params?.inid);
  }, []);

  useEffect(() => {
    setInvInfo(invDetail);
  }, [invDetail]);

  useEffect(() => {
    setIsLoader(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (errMsg) {
      toast.error(errMsg);
    }
  }, [errMsg]);

  return (
    <div
      className={`accounts-container h-full flex flex-col mt-2 md:static overflow-y-auto relative ${
        isLoader ? "-mt-[70px]" : ""
      }`}
    >
      {isLoader ? (
        <div className="flex h-full justify-center align-center">
          <Loader />
        </div>
      ) : (
        <>
          <PageHeader
            isBackBtn={true}
            onBackClick={() => navigate("/invoices")}
            svg={<Invoices color={"white"} width="24" height="24" />}
            text="Invoice"
            subTitle={invInfo?.invoiceNo}
          />
          <div className="accordianWrapper">
            <Accordion
              allowMultipleExpanded={true}
              allowZeroExpanded={true}
              preExpanded={["0", "1", "2", "3", "4", "5", "6"]}
              onChange={(item) => setOpenAcc(item)}
            >
              <AccordionItem uuid={"0"} className="accItem mb-4">
                <AccordionItemHeading>
                  <AccordionItemButton
                    className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center ${
                      openAcc.includes("0")
                        ? "md:rounded-t-lg"
                        : "md:rounded-lg"
                    }`}
                  >
                    <div className=" flex flex-row font-semibold md:text-[22px] text-base accTitle">
                      <img src={InfoImg} alt="infoImg" className="mr-2" />
                      Information
                    </div>
                    <AccordionItemState>
                      {({ expanded }) =>
                        expanded ? (
                          <div className="accIconOpen inline-block mr-3" />
                        ) : (
                          <div className="accIconClose inline-block mr-3 rotate-45" />
                        )
                      }
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div className="bg-white-100 accPanel grid md:rounded-b-lg py-5 px-4">
                    <div className="grid md:grid-cols-2  md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Invoice#
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          <span className="text-primary">
                            {invInfo?.invoiceNo}
                          </span>
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          SAP Invoice No
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {invInfo?.sapInvoiceNo}
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2  md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base text-primary">
                          Account
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          <span className="text-primary">
                            {invInfo?.accountName}
                          </span>
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base flex items-center">
                          Amount
                          {/* <InfoVector className="ms-2" /> */}
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          <span className="text-primary">
                            {numberFormat(invInfo?.amount)}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2 md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base flex items-center">
                          Invoice Date
                          {/* <InfoVector className="ms-2" /> */}
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {formateDate(invInfo?.invoiceDate)}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Currency
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {invInfo?.currencySign}
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2 md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Shipping Charge
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {numberFormat(invInfo?.shippingCharge)}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base flex items-center">
                          Payment Days
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {invInfo?.paymentDurationDays}
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2 md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Cash Discount
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {invInfo?.cashDiscount}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Cash Discount Amount
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {invInfo?.cashDiscountAmount}
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2">
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Clearing Date
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {formateDate(invInfo?.clearingDate)}
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionItemPanel>
              </AccordionItem>

              <AccordionItem uuid={"1"} className="accItem mb-3 w-full">
                <AccordionItemHeading>
                  <AccordionItemButton
                    className={`accButton py-4 px-4 flex flex-row justify-between items-center ${
                      openAcc.includes("1")
                        ? "md:rounded-t-lg"
                        : "md:rounded-lg"
                    }`}
                  >
                    <div className="flex flex-row accTitle">
                      <img src={Order2Img} alt="AddressImg" className="mr-2" />
                      Invoice Items
                    </div>
                    <AccordionItemState>
                      {({ expanded }) =>
                        expanded ? (
                          <div className="accIconOpen inline-block mr-3" />
                        ) : (
                          <div className="accIconClose inline-block mr-3 rotate-45" />
                        )
                      }
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div className="accPanel grid md:rounded-b-lg py-5 px-4">
                    {invInfo?.invoiceLineList?.length > 0 ? (
                      <div className="table-container card w-full overflow-auto">
                        <div className="w-full overflow-auto order-list-table shadow-sm md:rounded-md p-0 relative">
                          <table className="w-full">
                            <thead>
                              <tr role="row">
                                {invInfo?.fields?.map((field, index) => {
                                  return (
                                    field?.fieldLabel && (
                                      <th
                                        key={index}
                                        colspan="1"
                                        role="columnheader"
                                        className={`p-3 md:min-w-fit min-w-[180px] ${
                                          index === 1
                                            ? "left-0 z-[3] !min-w-[150px]"
                                            : "!min-w-[200px]"
                                        }`}
                                      >
                                        {field?.fieldLabel}
                                      </th>
                                    )
                                  );
                                })}
                              </tr>
                            </thead>
                            <tbody>
                              {invInfo?.invoiceLineList?.map((row, i) => (
                                <tr role="row" key={i}>
                                  {invInfo?.fields?.map((field, index) => {
                                    return (
                                      field?.fieldLabel && (
                                        <td
                                          key={index}
                                          role="cell"
                                          className={`p-3 md:text-base text-sm ${
                                            index === 1
                                              ? "sticky left-0 z-[2]"
                                              : ""
                                          }`}
                                        >
                                          {getFormatedData(
                                            field.fieldType,
                                            row[field?.fieldName]
                                          )}
                                        </td>
                                      )
                                    );
                                  })}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </AccordionItemPanel>
              </AccordionItem>

              <AccordionItem uuid={"2"} className="accItem mb-4">
                <AccordionItemHeading>
                  <AccordionItemButton
                    className={`bg-white-200 py-4 px-4 flex flex-row justify-between items-center ${
                      openAcc.includes("2")
                        ? "md:rounded-t-lg"
                        : "md:rounded-lg"
                    }`}
                  >
                    <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                      <TaxSvg className="mr-2" />
                      TAX Detail
                    </div>
                    <AccordionItemState>
                      {({ expanded }) =>
                        expanded ? (
                          <div className="accIconOpen inline-block mr-3" />
                        ) : (
                          <div className="accIconClose inline-block mr-3 rotate-45" />
                        )
                      }
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div className="accPanel bg-white-100 grid md:rounded-b-lg py-5 px-4">
                    <div className="grid md:grid-cols-2 md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:mb-0 mb-4 pb-2 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          CGST AMOUNT
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {numberFormat(invInfo?.cgstAmount)}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:mb-0 mb-4 pb-2 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          IGST AMOUNT
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {numberFormat(invInfo?.igstAmount)}
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2">
                      <div className="grid grid-cols-2 fieldWrapper pb-2 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          SGST AMOUNT
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {numberFormat(invInfo?.sgstAmount)}
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionItemPanel>
              </AccordionItem>

              <AccordionItem uuid={"3"} className="accItem mb-4">
                <AccordionItemHeading>
                  <AccordionItemButton
                    className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center ${
                      openAcc.includes("3")
                        ? "md:rounded-t-lg"
                        : "md:rounded-lg"
                    }`}
                  >
                    <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                      <PaymentSvg className="mr-2" />
                      Payment Information
                    </div>
                    <AccordionItemState>
                      {({ expanded }) =>
                        expanded ? (
                          <div className="accIconOpen inline-block mr-3" />
                        ) : (
                          <div className="accIconClose inline-block mr-3 rotate-45" />
                        )
                      }
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div className="bg-white-100 accPanel grid md:rounded-b-lg py-5 px-4">
                    <div className="grid md:grid-cols-2 md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:mb-0 mb-4  pb-2 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base flex items-center">
                          Balance
                          {/* <InfoVector className="ms-2" /> */}
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {numberFormat(invInfo?.balance)}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:mb-0 mb-4  pb-2 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Payment Terms
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {invInfo?.paymentTerms}
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2">
                      <div className="grid grid-cols-2 fieldWrapper md:mb-0 mb-4  pb-2 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Due Date
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {formateDate(invInfo?.dueDate)}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper pb-2 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Payment Status
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {invInfo?.paymentStatus}
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionItemPanel>
              </AccordionItem>

              <AccordionItem uuid={"4"} className="accItem mb-4">
                <AccordionItemHeading>
                  <AccordionItemButton
                    className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center ${
                      openAcc.includes("4")
                        ? "md:rounded-t-lg"
                        : "md:rounded-lg"
                    }`}
                  >
                    <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                      <TrackingSvg className="mr-2" />
                      Tracking Information
                    </div>
                    <AccordionItemState>
                      {({ expanded }) =>
                        expanded ? (
                          <div className="accIconOpen inline-block mr-3" />
                        ) : (
                          <div className="accIconClose inline-block mr-3 rotate-45" />
                        )
                      }
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div className="bg-white-100 accPanel grid md:rounded-b-lg py-5 px-4">
                    <div className="grid md:grid-cols-2 md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:mb-0 mb-4  pb-2 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Transport Company Name
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {invInfo?.transportCompanyName}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:mb-0 mb-4  pb-2 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Tracking URL
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {invInfo?.trackingURL}
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2 md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:mb-0 mb-4  pb-2 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Docket Number
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {invInfo?.docketNumber}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:mb-0 mb-4  pb-2 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          No. of Cartons
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {invInfo?.noOfCartons}
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2 ">
                      <div className="grid grid-cols-2 fieldWrapper md:mb-0 mb-4  pb-2 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          E-Way Bill Number
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {invInfo?.eWayBillNumber}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper pb-2 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Vehicle Registration Number
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {invInfo?.vehicleRegistrationNumber}
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionItemPanel>
              </AccordionItem>

              <AccordionItem uuid={"5"} className="accItem mb-4">
                <AccordionItemHeading>
                  <AccordionItemButton
                    className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center ${
                      openAcc.includes("5")
                        ? "md:rounded-t-lg"
                        : "md:rounded-lg"
                    }`}
                  >
                    <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                      <TaxSvg className="mr-2" />
                      TAT Information
                    </div>
                    <AccordionItemState>
                      {({ expanded }) =>
                        expanded ? (
                          <div className="accIconOpen inline-block mr-3" />
                        ) : (
                          <div className="accIconClose inline-block mr-3 rotate-45" />
                        )
                      }
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div className="bg-white-100 accPanel grid md:rounded-b-lg py-5 px-4">
                    <div className="grid md:grid-cols-2 md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:mb-0 mb-4  pb-2 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          LR Date
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {invInfo?.lrDate}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:mb-0 mb-4  pb-2 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Delivery Date
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {invInfo?.deliveryDate}
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2 md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:mb-0 mb-4  pb-2 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Target TAT (Days)
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {invInfo?.targetTATDays}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:mb-0 mb-4  pb-2 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Delivery Confirmed
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {invInfo?.deliveryConfirmed}
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2 ">
                      <div className="grid grid-cols-2 fieldWrapper md:mb-0 mb-4  pb-2 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Achieved TAT (Days)
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {invInfo?.achievedTATDays}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper pb-2 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          POD Received
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {invInfo?.podReceived}
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionItemPanel>
              </AccordionItem>

              <AccordionItem uuid={"6"} className="accItem mb-4">
                <AccordionItemHeading>
                  <AccordionItemButton
                    className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center ${
                      openAcc.includes("6")
                        ? "md:rounded-t-lg"
                        : "md:rounded-lg"
                    }`}
                  >
                    <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                      <img src={AddressImg} alt="infoImg" className="mr-2" />
                      Address Information
                    </div>
                    <AccordionItemState>
                      {({ expanded }) =>
                        expanded ? (
                          <div className="accIconOpen inline-block mr-3" />
                        ) : (
                          <div className="accIconClose inline-block mr-3 rotate-45" />
                        )
                      }
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div className="bg-white-100 accPanel grid md:rounded-b-lg py-5 px-4">
                    <div className="grid md:grid-cols-2 md:mb-4">
                      <div className="grid md:grid-cols-2 pb-2 pl-0 px-3 md:mr-10">
                        <div className="md:mr-10 md:mb-0 mb-4">
                          <div className="fieldName font-normal md:text-lg text-base mb-2">
                            Billing Address :
                          </div>
                          <div className="fieldDetails font-medium md:text-base text-sm">
                            <div className="flex flex-row rounded-lg p-4 addressData">
                              {invInfo?.billingStreet},<br />
                              {invInfo?.billingCity},{" "}
                              {invInfo?.billingPostalCode}
                              ,
                              <br />
                              {invInfo?.billingState},<br />
                              {invInfo?.billingCountry}
                            </div>
                          </div>
                        </div>
                        <div className="md:mb-0 mb-4">
                          <div className="fieldName font-normal md:text-lg text-base mb-2">
                            Shipping Address :
                          </div>
                          <div className="fieldDetails font-medium md:text-base text-sm">
                            <div className="flex flex-row rounded-lg p-4 addressData">
                              {invInfo?.shippingStreet},<br />
                              {invInfo?.shippingCity},{" "}
                              {invInfo?.shippingPostalCode}
                              ,<br />
                              {invInfo?.shippingState},<br />
                              {invInfo?.shippingCountry}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2">
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base flex items-center">
                          Shipping Incoterms
                          {/* <InfoVector className="ms-2" /> */}
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {invInfo?.incoterms}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Shipping Incoterms Location
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {invInfo?.incotermsLocation}
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </div>
        </>
      )}
    </div>
  );
};

export default InvoicesDetails;
